import React, { useRef, useState } from "react"
import { Form, Input, Button, Typography, message, Spin, Card } from "antd"
import { UserAddOutlined } from "@ant-design/icons"
import ClientSearchService from "src/services/ClientSearchService"
import { useNavigate } from "react-router-dom"
import ROUTER from "src/router"
import MathCaptcha from "../HomePage/components/MathCaptcha"

const { Title, Paragraph } = Typography

const PartnerRegister = () => {
  const [captchaValue, setCaptchaValue] = useState(null)
  const [isVerified, setIsVerified] = useState(false)
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const handleCaptchaChange = value => {
    setCaptchaValue(value)
  }

  const onFinish = async values => {
    // if (!captchaValue) {
    //   message.error("Vui lòng xác nhận Captcha!")
    //   return
    // }
    if (!isVerified) {
      message.warning("Vui lòng xác thực trước khi tra cứu.")
      return
    }
    
    try {
      setLoading(true)
      const payload = { ...values }
      await ClientSearchService.Register(payload)

      message.success("Gửi đăng ký thành công!")
      navigate(ROUTER.MAIN_PAGE)

      form.resetFields()
      setCaptchaValue(null)
    } catch (error) {
      console.error("Lỗi gửi form:", error)
      message.error("Lỗi gửi đăng ký. Vui lòng thử lại sau.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      style={{
        minHeight: "100%",
        background: "linear-gradient(to bottom, #f8f9fa, #e9ecef)",
        padding: "24px 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card
        style={{
          maxWidth: 520,
          width: "100%",
          borderRadius: "24px",
          padding: "32px 24px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
          border: "1px solid rgba(255,255,255,0.2)",
          backdropFilter: "blur(20px)",
        }}
        bodyStyle={{ padding: 0 }}
      >
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div
            style={{
              background: "linear-gradient(135deg, #1890ff, #096dd9)",
              borderRadius: "50%",
              width: 60,
              height: 60,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 auto 16px",
              boxShadow: "0 4px 20px rgba(102, 126, 234, 0.3)",
            }}
          >
            <UserAddOutlined style={{ fontSize: 28, color: "#fff" }} />
          </div>
          <Title level={3} style={{ margin: 0, fontWeight: 600 }}>
            Đăng ký cộng tác viên
          </Title>
          <Paragraph style={{ color: "#666", margin: "8px 0 0" }}>
            Điền thông tin để chúng tôi liên hệ với bạn
          </Paragraph>
        </div>
        <Spin spinning={loading}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ padding: "0 8px" }}
          >
            <Form.Item
              label="Họ và tên"
              name="name"
              rules={[{ required: true, message: "Vui lòng nhập họ tên!" }]}
            >
              <Input size="large" placeholder="Nguyễn Văn A" />
            </Form.Item>

            <Form.Item
              label="Số điện thoại"
              name="phone"
              rules={[
                { required: true, message: "Vui lòng nhập số điện thoại!" },
                {
                  pattern: /^0\d{9}$/,
                  message: "Số điện thoại không hợp lệ",
                },
              ]}
            >
              <Input size="large" placeholder="0987xxxxxx" />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Vui lòng nhập email!" },
                { type: "email", message: "Email không hợp lệ!" },
              ]}
            >
              <Input size="large" placeholder="abc@example.com" />
            </Form.Item>

            <div style={{ marginBottom: 20 }}>
              <div
                style={{
                  transform: "scale(0.85)",
                  transformOrigin: "0 0",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <MathCaptcha onVerify={setIsVerified} />
              </div>
            </div>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                block
                size="large"
                disabled={!isVerified}
                style={{
                  height: "48px",
                  borderRadius: "16px",
                  background: "linear-gradient(135deg, #1890ff, #096dd9)",
                  border: "none",
                  fontWeight: 600,
                  fontSize: 16,
                  boxShadow: "0 4px 20px rgba(102, 126, 234, 0.3)",
                }}
              >
                Gửi đăng ký
              </Button>
            </Form.Item>
          </Form>
        </Spin>
      </Card>
    </div>
  )
}

export default PartnerRegister
